// Counts files replaced in place this session. A replaced file keeps its url,
// so anything cached by url (like a PDF's first-page thumbnail) reads this to
// know the content under it changed. No imports, so the uploader and the
// components that read it can both depend on it without a cycle.

const replaced = new Map<string, number>();
const listeners = new Set<() => void>();

/**
 * One spelling per stored file: no query or hash, each segment decoded
 * @param {string} path stored url, e.g. /general/report.pdf
 */
function normalise(path: string) {
  return String(path).split(/[?#]/)[0].split('/').map((segment) => {
    try {
      return decodeURIComponent(segment);
    } catch (e) {
      return segment;
    }
  }).join('/');
}

/**
 * Record that the file stored at `path` was replaced, and tell listeners
 * @param {string} path stored url, e.g. /general/report.pdf
 */
export function markMediaReplaced(path: string) {
  const key = normalise(path);
  replaced.set(key, (replaced.get(key) || 0) + 1);
  listeners.forEach((listener) => listener());
}

/**
 * How many times the file stored at `path` was replaced this session
 * @param {string} path stored url
 */
export function mediaReplacedCount(path: string) {
  return replaced.get(normalise(path)) || 0;
}

/**
 * Run `listener` after any file is replaced
 * @param {() => void} listener
 * @returns unsubscribe
 */
export function onMediaReplaced(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
